var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgYellowStar = function SvgYellowStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_yellow_star)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9082 33.5416C74.9514 32.332 74.0457 31.331 72.8381 31.1642L54.5949 28.62C53.8186 28.4948 53.1286 28.036 52.7836 27.327L44.6324 11.3109C44.0286 10.143 42.6054 9.68423 41.3978 10.2264C40.9234 10.435 40.5352 10.8104 40.2764 11.3109L32.1252 27.2853C31.7802 27.9943 31.0902 28.4531 30.3139 28.5783L12.1138 31.1225C10.9063 31.2893 10.0006 32.332 10.0437 33.4999V38.2964C10.0006 38.9637 10.2593 39.6311 10.7769 40.0898L23.974 52.519C24.0172 52.5607 24.0603 52.6024 24.1034 52.6859L21.5158 67.2005C21.3864 67.9512 21.4726 72.8729 21.5158 72.9146C21.5589 73.1231 21.602 73.3317 21.6883 73.5402C21.6883 73.5819 21.7314 73.6236 21.7745 73.707C21.9039 73.9573 22.0764 74.1658 22.2489 74.3327C22.3783 74.4578 22.5077 74.5412 22.6371 74.6246C23.0252 74.8332 23.4565 75 23.8878 75C24.0172 75 24.1466 75 24.2328 75C24.3622 74.9583 24.5347 74.9583 24.6641 74.9166L24.7935 74.8749L24.966 74.7915L25.0522 74.7497L41.3546 66.4497C42.0447 66.0743 42.9073 66.0743 43.5973 66.4497L59.8997 74.708L59.986 74.7497C60.2447 74.8749 60.5035 74.9166 60.7623 74.9583C60.8916 74.9583 60.9779 74.9583 61.1073 74.9583C61.2367 74.9583 61.3229 74.9583 61.4523 74.9166C62.4443 74.7497 63.2637 73.999 63.4362 73.0397C63.4793 72.9146 63.4793 72.8312 63.4793 72.706C63.4793 72.5809 63.5656 67.9095 63.4362 67.1588L60.8916 52.6859C60.9348 52.6442 60.9779 52.5607 61.0642 52.519L74.2613 40.0898C74.7789 39.6311 75.0376 38.9637 74.9945 38.2964L74.9082 33.5416Z",
    fill: "url(#paint0_linear_yellow_star)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6322 11.3126L52.7834 27.287C53.1284 27.9961 53.8184 28.4549 54.5947 28.58L72.8379 31.1242C74.1749 31.3328 75.0806 32.5006 74.908 33.7936C74.8218 34.2941 74.563 34.7529 74.218 35.1283L61.0208 47.5574C60.4602 48.0997 60.2014 48.8921 60.3308 49.6429L63.436 67.2022C63.6516 68.4952 62.7891 69.7047 61.4521 69.9133C60.9346 69.9967 60.3739 69.9133 59.8995 69.663L43.5971 61.363C42.907 60.9876 42.0445 60.9876 41.3544 61.363L25.052 69.663C23.8445 70.2469 22.3781 69.8299 21.7743 68.662C21.5155 68.2032 21.4293 67.661 21.5155 67.1605L24.6208 49.6012C24.7501 48.8504 24.4914 48.0579 23.9307 47.5157L10.7335 35.17C9.78473 34.2524 9.7416 32.7509 10.6904 31.8333C11.0786 31.4579 11.553 31.2076 12.0705 31.1659L30.2705 28.6217C31.0468 28.4966 31.7369 28.0378 32.0819 27.3287L40.2331 11.3543C40.8369 10.1865 42.2601 9.72769 43.4677 10.2699C44.0284 10.4784 44.4165 10.8538 44.6322 11.3126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.022 67.6616C60.8495 67.6616 60.7201 67.6198 60.5476 67.5364L44.2452 59.2364C43.1239 58.6525 41.7438 58.6525 40.6224 59.2364L24.3632 67.5781C24.2338 67.6616 24.0613 67.7033 23.9319 67.7033C23.63 67.7033 23.3712 67.5781 23.1987 67.3696C23.0262 67.1611 22.9399 66.8691 22.9831 66.6188L26.0883 49.0595C26.3039 47.8499 25.8726 46.5987 24.967 45.7228L11.7267 33.2519C11.3385 32.8765 11.3385 32.2926 11.7267 31.9172C11.856 31.7504 12.0717 31.667 12.2873 31.6253L30.5305 29.0811C31.7812 28.9142 32.9025 28.1218 33.4632 27.0373L41.6144 11.0629C41.8731 10.6041 42.4338 10.4373 42.9513 10.6875C43.1239 10.7709 43.2532 10.8961 43.3395 11.0629L51.4907 27.0373C52.0514 28.1635 53.1727 28.9142 54.4234 29.0811L72.6665 31.6253C73.1841 31.7087 73.5722 32.1675 73.486 32.668C73.4429 32.8765 73.3566 33.0434 73.1841 33.2102L59.9869 45.6394C59.0812 46.5153 58.6499 47.7665 58.8656 48.9761L61.9708 66.5354C62.0139 66.7857 61.9708 67.0776 61.7552 67.2862C61.5826 67.5364 61.3239 67.6616 61.022 67.6616Z",
    fill: "url(#paint1_linear_yellow_star)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_yellow_star",
    x: -4,
    y: 0,
    width: 93,
    height: 93,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_yellow_star",
    x1: 18.4761,
    y1: 24.2904,
    x2: 64.8445,
    y2: 72.2325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D4214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_yellow_star",
    x1: 42.4554,
    y1: 67.6908,
    x2: 42.4554,
    y2: 10.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD700"
  })))));
};
export default __webpack_public_path__ + "static/media/yellow-star.3770df91.svg";
export { SvgYellowStar as ReactComponent };